import { Link as LinkComponent } from '@firsttable/web-components/atoms';
import withAnalyticsComponent from '../hocs/withAnalyticsComponent';

const Link = (props) => <LinkComponent {...props} />;

export default withAnalyticsComponent(Link, 'link');
